import React from "react";
import {useSelector} from "react-redux";
import MediaCard from "../../components/ui/MediaCard";
import souscriptionExpiree from './images/cards/souscription_expiree.png';
import soldeEpuise from './images/cards/solde_epuise.png';
import suspendu from './images/cards/acces_suspendu.png';


const OnlyForPublicRoute = ({ children }) => {
  let imageToDisplay = null // Default image

  const isLogged = useSelector((state) => Boolean(state.auth.login.user));
  const hasSolde = useSelector((state) => state.auth.login.hasSolde);
  const isValide = useSelector((state) => state.auth.login.isValide);
  const isSuspendu = useSelector((state) => state.auth.login.isSuspendu);

  if (hasSolde) {
    imageToDisplay = soldeEpuise;
  } else if (isSuspendu) {
    imageToDisplay = suspendu;
  }
  else if (isValide) {
    imageToDisplay = souscriptionExpiree;
  }
    const validSouscription = hasSolde || isSuspendu || isValide

  return !isLogged ? (
      children
  ) : ( validSouscription ?
      <MediaCard souscriptionImage={imageToDisplay} /> :null
  );
};

export default OnlyForPublicRoute;
